import { HttpErrorService } from '@/services/HttpError.service'
import type { Location } from '@/models'
import { orderKitErrorHandbook } from '@/models'
import { HttpService } from '@/services/Http.service'

export class LocationService {
  private httpErrorService: HttpErrorService<keyof typeof orderKitErrorHandbook>
  private endpoint = '/cities'
  private httpService: HttpService

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(
      orderKitErrorHandbook,
      'location',
    )
  }

  async getAll() {
    const url = [this.endpoint].join('/')

    return await this.httpService
      .get<Location[]>(url, {
        requestConfig: {
          cancellable: true,
          needCancelAtChangeRoute: true,
          cache: {
            server: {
              allCities: true,
              lifeTime: getMilliseconds.inMinutes(5),
            },
          },
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }
}
